import camelcaseKeys from 'camelcase-keys'
import { cloneDeep, map } from 'lodash'

// NOTE: サーバーはjsonbをそのまま返すため、プラン内部のキーだけスネークケースのまま届く。
// 画面側はcamelCaseで統一したいので受け取り口で変換する。
export const normalizeExtensionPlan = rawExtensionPlan => {
  // NOTE: コースはプランの本体。無ければプランとして扱わない
  if (!rawExtensionPlan?.course) return null

  const plan = camelcaseKeys(rawExtensionPlan, { deep: true })

  return {
    course: plan.course,
    nominations: plan.nominations || [],
    items: plan.items || [],
  }
}

const buildPlanEntry = vendingHistoryTemp => {
  return {
    vendibleId: vendingHistoryTemp.value.vendibleId,
    vendibleType: vendingHistoryTemp.value.vendibleType,
    sellingPrice: Number(vendingHistoryTemp.value.sellingPrice) || 0,
    taxCharge: vendingHistoryTemp.value.taxCharge,
    size: vendingHistoryTemp.size,
    recipients: map(vendingHistoryTemp.value.vendibleRecipientsAttributes || [], recipient => ({
      userId: recipient.userId,
      ratio: recipient.ratio,
    })),
  }
}

// NOTE: 編集中のvendingHistoryTempから保持プラン(PUTのボディ)を組む
export const buildExtensionPlanPayload = ({ courseTemp, nominationTemps, itemTemps }) => {
  return {
    course: buildPlanEntry(courseTemp),
    nominations: map(nominationTemps, buildPlanEntry),
    items: map(itemTemps, buildPlanEntry),
  }
}

// NOTE: 保持プランを編集モーダルのシード（vendingHistoryTempの束）に戻す
export const buildSeedFromExtensionPlan = (extensionPlan, buildVendingHistoryTemp) => {
  const toTemp = entry => buildVendingHistoryTemp({
    vendibleId: entry.vendibleId,
    vendibleType: entry.vendibleType,
    sellingPrice: entry.sellingPrice,
    size: entry.size || 1,
    taxCharge: entry.taxCharge,
    vendibleRecipientsAttributes: map(entry.recipients || [], recipient => ({
      userId: recipient.userId,
      ratio: recipient.ratio,
    })),
  })

  return {
    course: toTemp(extensionPlan.course),
    nominations: map(extensionPlan.nominations || [], toTemp),
    items: map(extensionPlan.items || [], toTemp),
  }
}

// NOTE: 延長候補カードの内容を編集モーダルのシードにする（候補側の状態を編集で汚さないようクローンする）
export const buildSeedFromCandidate = candidate => {
  return {
    course: cloneDeep(candidate.courseHistoryTemp),
    nominations: cloneDeep(candidate.nominationHistoriesTemp || []),
    items: cloneDeep(candidate.itemHistoriesTemp || []),
  }
}
